import { combineReducers } from "redux";
import * as types from "./types";
import { createReducer } from "../../utils";

const listReducer = createReducer([])({
    [types.SALES_DASHBOARD_COMPLETED]: (state, action) => {
        return action.payload.payload
    },
    [types.CUSTOMER_DASHBOARD_COMPLETED]: (state, action) => {
        return action.payload.payload
    },
    [types.QUESTION_DASHBOARD_COMPLETED]: (state, action) => {
        return action.payload.payload
    }
});

export default combineReducers({
    list: listReducer
});